import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type InsightsEmptyStateProps = {
  type: 'inProgress' | 'noData' | 'migratedFromV1'
  noBorder?: boolean
}

export const InsightsEmptyState: React.FC<InsightsEmptyStateProps> = ({
  type,
  noBorder = false,
}) => {
  const title = {
    inProgress: i18n.t('performance_process.targets.insights.empty_states.in_progress.title'),
    noData: i18n.t('performance_process.targets.insights.empty_states.no_data.title'),
    migratedFromV1: i18n.t(
      'performance_process.targets.insights.empty_states.migrated_from_v1.title'
    ),
  }

  const description = {
    inProgress: i18n.t('performance_process.targets.insights.empty_states.in_progress.description'),
    noData: i18n.t('performance_process.targets.insights.empty_states.no_data.description'),
    migratedFromV1: i18n.t(
      'performance_process.targets.insights.empty_states.migrated_from_v1.description'
    ),
  }

  return (
    <Box
      flexGrow
      gap="s16"
      paddingY="s24"
      paddingX="s48"
      borderRadius={{ all: 'abs006' }}
      border={noBorder ? {} : { all: { style: 'solid', width: 's1', color: 'grey400' } }}
      textAlign="center"
      alignItems="center"
      justifyContent={noBorder ? 'center' : 'flexStart'}
    >
      <Icon.Medium icon="ai" color="viridian1000" />
      <Text.Header2 weight="bold">{title[type]}</Text.Header2>
      <Text.Normal>{description[type]}</Text.Normal>
    </Box>
  )
}
